import React from 'react'
import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import medendoLogo from '../assets/medendo_logo.png'

type AccountDisabledProps = {
    onLogout: () => void
}

/**
 * Terminal screen for a signed-in user whose account has been deactivated.
 *
 * The backend refuses every request from such an account, so there is nothing for the app shell to
 * show: without this screen the user is left with empty panels and error snackbars for a state that
 * is entirely intentional. Signing out is the only way forward, and it lets the user try another
 * account on a shared device.
 */
const AccountDisabled: React.FC<AccountDisabledProps> = ({ onLogout }) => {
    const { t } = useTranslation()

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
            }}
        >
            <Paper>
                <Stack justifyContent="center" alignItems="stretch" width={400} p={2} spacing="12px">
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: '12px' }}>
                        <img src={medendoLogo} alt={t('common.logo_alt')} width={200} />
                    </Box>
                    <Typography variant="h6" align="center">
                        {t('account_disabled.title')}
                    </Typography>
                    <Typography variant="body1" align="center" sx={{ whiteSpace: 'pre-line' }}>
                        {t('account_disabled.message')}
                    </Typography>
                    <Button variant="contained" onClick={onLogout}>
                        {t('account_disabled.logout_button')}
                    </Button>
                </Stack>
            </Paper>
        </Box>
    )
}

export default AccountDisabled
